import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/pages.css';

function Appointment() {
    const [formData, setFormData] = useState({
        firstname: '',
        lastname: '',
        phone: '',
        messages: '',
        consent: false,
        selected_department: '',
        selected_doctor: '',
    });

    const [errors, setErrors] = useState({});

    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [doctors, setDoctors] = useState([]);
    const [selectedDoctors, setSelectedDoctors] = useState('');


    useEffect(() => {
        // Fetch departments
        fetch('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_departments.php')
        .then(response => response.json())
        .then(data => setDepartments(data))
        .catch(error => console.error('Error fetching departments:', error));
    }, []);

    const handleDepartmentChange = (e) => {
        const department = e.target.value;
        setSelectedDepartment(department);
        setFormData({
            ...formData,
            selected_department: department,
        });

        fetch(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php?department=${encodeURIComponent(department)}`)
            .then(response => response.json())
            .then(data => setDoctors(data))
            .catch(error => console.error('Error fetching doctors:', error));
    };

    const handleDoctorChange = (e) => {
        const doctor = e.target.value;
        setSelectedDoctors(doctor);
        setFormData({
            ...formData,
            selected_doctor: doctor,
        });

        console.log("selected Doctor : ", doctor)
    }

    const validateInput = (name, value) => {
        let error = '';
        switch (name) {
            case 'firstname':
            case 'lastname':
                if (!value.match(/^[A-Za-z]+$/)) {
                    error = 'This field should only contains alphabets.';
                }
                break;
            case 'email':
                if (!value.match(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/)) {
                    error = 'Please enter a valid email address.';
                }
                break;
            default:
                break;
        }
        return error;
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const error = validateInput(name, value);
        setErrors({
            ...errors,
            [name]: error
        });
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        console.log('Form data:', formData);
    
        const validationErrors = {};
        let isValid = true;
    
        Object.keys(formData).forEach((key) => {
            const error = validateInput(key, formData[key]);
            if (error) {
                isValid = false;
                validationErrors[key] = error;
            }
        });
    
        setErrors(validationErrors);
    
        if (!isValid) {
            return;
        }
    
        fetch('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/appointment_form.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
        .then(response => response.json())
        .then(data => {
            if (data.status === 'success') {
                setSuccessMessage(data.message);
                setErrorMessage(''); 
                setIsSubmitted(true); 
                setFormData({ 
                    firstname: '',
                    lastname: '',
                    phone: '',
                    selected_department: '',
                    selected_doctor: '',
                    doctor: '',
                    messages: '',
                    consent: false
                });
                setErrors({});
            } else {
                setErrorMessage(data.message);
                setSuccessMessage('');
            }
        })
        .catch((error) => {
            setErrorMessage('An error occurred. Please try again later.');
            setSuccessMessage('');
        });
    };
    return (
        <div>
            {/* Navbar */}
            <Navbar />
            {/* Navbar Ending */}

            {/* Page Content starts here */}
            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Appointments</p>

                    <div className="d-none d-md-block"> {/* Visible on desktop, hidden on mobile */}
                        <p className="page-subtitle">
                            Get in Touch With Caritas Matha Hospital for Inquiries, 
                            <br/>
                            Appointments, and Assistance.
                        </p>
                    </div>

                    <div className="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
                        <p className="page-subtitle">
                            Get in Touch With Caritas Matha Hospital for Inquiries, Appointments, and Assistance.
                        </p>
                    </div>
                </div>

                <p>&nbsp;</p>
                <div className="appointment-desktop"> {/* Visible on desktop, hidden on mobile */}
                    <p className='appointment-content'>
                        For appointments, please call us at <a href="tel:04812792500">0481-2792500</a>, and our team will 
                        <br/>
                        assist you promptly.
                    </p>
                </div>

                <div className="appointment-mobile"> {/* Visible on mobile, hidden on desktop */}
                    <p className='appointment-mobile-content'>
                        For appointments, please call us at <a href="tel:04812792500">0481-2792500 </a>, and our team will assist you promptly.
                    </p>
                </div>
            </section>

            <section className="contact-us-container">
                {/* Contact Us Column */}
                <div className="contact-us-column">
                    <h6 className="contact-sub-heading">Address</h6>
                    <p className="footer-links"> MC Road, Thellakom (P.O), <br />Kottayam, Kerala - 686630</p>

                    <h6 className="contact-sub-heading">Contact Number</h6>
                    <a href="tel:04812792500"><p className="footer-links"> 0481-2792500</p></a>

                    <h6 className="contact-sub-heading">Email Id</h6>
                    <a href="mailto:cmh@caritashospital.org"><p className="footer-links">cmh@caritashospital.org</p></a>
                </div>

                {/* Contact Us Form */}
                <div className="contact-us-form">
                    {!isSubmitted ? (
                        <form onSubmit={handleSubmit}>
                            {/* firstname field */}
                            <div className="form-group">
                                <label style={{ color: 'red' }}>*</label>
                                <input
                                    type="text"
                                    name="firstname"
                                    value={formData.firstname}
                                    onChange={handleChange}
                                    placeholder="First Name"
                                    required
                                    className="form-control"
                                />
                                {errors.firstname && <div style={{ color: 'red' }}>{errors.firstname}</div>}
                            </div>
                            {/* Lastname field */}
                            <div className="form-group">
                                <label style={{ color: 'red' }}>*</label>
                                <input
                                    type="text"
                                    name="lastname"
                                    value={formData.lastname}
                                    onChange={handleChange}
                                    placeholder="Last Name"
                                    required
                                    className="form-control"
                                />
                                {errors.lastname && <div style={{ color: 'red' }}>{errors.lastname}</div>}
                            </div>

                            {/* phone number field */}
                            <div className="form-group">
                                <label style={{ color: 'red' }}>*</label>
                                <input 
                                    type="text" 
                                    name="phone"
                                    className="form-control"
                                    value={formData.phone} 
                                    onChange={handleChange} 
                                    placeholder='Phone Number' 
                                    required 
                                    pattern="\d*"
                                    onInput={(e) => 
                                        e.target.value = e.target.value.replace(/[^0-9]/g, '')} 
                                    />
                            </div>
                            
                            {/* Department selection field */}
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label style={{ color: 'red' }}>*</label>
                                    <select 
                                        name="selected_department" 
                                        value={selectedDepartment} 
                                        onChange={handleDepartmentChange} 
                                        className='form-control' 
                                        required
                                    >
                                        <option value="">Select A Department</option>
                                        {departments.map(dept => (
                                            <option 
                                                key={dept.pk} 
                                                value={dept.name}
                                            >
                                                {dept.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* Doctors Name Field */}
                                {/* <div className="form-group col-md-6">
                                    <label style={{ color: 'red' }}>*</label>
                                    <input 
                                        type="text" 
                                        name="doctor"
                                        className="form-control"
                                        value={formData.doctor} 
                                        onChange={handleChange} 
                                        placeholder='Enter Doctor Name' 
                                        required 
                                    />
                                </div> */}

                                <div className="form-group col-md-6">
                                    <label style={{ color: 'red' }}>*</label>
                                    <select 
                                        name="selected_doctor" 
                                        value={selectedDoctors} 
                                        onChange={handleDoctorChange} 
                                        className='form-control' 
                                        required
                                    >
                                        <option value="">Select A Doctor</option>
                                        {doctors.map(doctor => (
                                            <option 
                                                key={doctor.pk} 
                                                value={doctor.pk}
                                            >
                                                {doctor.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Message Field */}
                            <div className="form-group">
                                <textarea
                                    name="messages"
                                    value={formData.messages}
                                    onChange={handleChange}
                                    placeholder="Message"
                                    className="form-control"
                                    rows="3"
                                    maxLength="500" 
                                    required
                                />
                            </div>
                            <div className="form-group form-check form-checkbox">
                                <input
                                    type="checkbox"
                                    name="consent"
                                    checked={formData.consent}
                                    onChange={handleChange}
                                    required
                                    className="form-check-input"
                                />
                                <label className="form-check-label">
                                By ticking, I agree to the Terms and Conditions, and I am giving my consent to receive updates through email and SMS. 
                                </label>
                            </div>

                            <button type="submit" className="form-button">Submit Now</button>
                        </form>
                    ) : (
                        <div className="success-message">
                            <h1>Thank You!</h1>
                            <p>Our Team Will Contact You Shortly.</p>
                        </div>
                    )}
                </div>
            </section>

            <section>
                <div className="contact-map-container">
                    <div className='map-title'>
                        <p className="sub-heading">Google Map Location</p>
                    </div>
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3933.429665891083!2d76.54812431602198!3d9.64830593217464!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b07d358c6fffffd%3A0x28bcae68ab08dd22!2sMatha%20Hospital!5e0!3m2!1sen!2sin!4v1697534628764!5m2!1sen!2sin"
                        width="95%"
                        height="500"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade">
                    </iframe>
                </div>
            </section>

            {/* Footer */}
            <Footer />
            {/* Footer Ending */}
        </div>
    );
}

export default Appointment;